import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
@Injectable({
    providedIn: 'root'
})
export class MpoDataService {
    constructor(private dataProvider: DataService) {
    }
    async CreateOffer(viewModel):Promise<any>{
            return this.dataProvider.Post<any>(Urls.CreateOffer,viewModel).toPromise();
        }
    async GetOffer(viewModel):Promise<any>{
                return this.dataProvider.Post<any>(Urls.GetOffer,viewModel).toPromise();
            }
}